import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  coursePauseRescheduleModalStageSelector,
  setCoursePauseRescheduleModalStage,
  setSelectedSuperBatch,
  setSelectedSbatLecture,
} from 'features/courseResume';
import CoursePauseRescheduleModalStageRenderer from '../CoursePauseRescheduleModalStageRenderer';

function CoursePauseRescheduleModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(coursePauseRescheduleModalStageSelector);
  const isModalOpen =
    modalStage !== COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.notOpen;
  const modalSize =
    modalStage === COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.unschedule
      ? 'large'
      : 'extraLarge';

  const handleClose = useCallback(() => {
    batch(() => {
      dispatch(setSelectedSuperBatch(null));
      dispatch(setSelectedSbatLecture(null));
      dispatch(
        setCoursePauseRescheduleModalStage(
          COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.notOpen
        )
      );
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      size={modalSize}
      unMountOnClose
      onClose={handleClose}
      withoutHeader
    >
      <CoursePauseRescheduleModalStageRenderer />
    </Modal>
  );
}

export default CoursePauseRescheduleModal;
